export default __webpack_public_path__ + "static/rs-feac46175cdeca2edc96bcc18bf1f347.svg";